import { render, staticRenderFns } from "./MyCoverSummary.vue?vue&type=template&id=6a30e7a3&"
import script from "./MyCoverSummary.vue?vue&type=script&lang=js&"
export * from "./MyCoverSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a30e7a3')) {
      api.createRecord('6a30e7a3', component.options)
    } else {
      api.reload('6a30e7a3', component.options)
    }
    module.hot.accept("./MyCoverSummary.vue?vue&type=template&id=6a30e7a3&", function () {
      api.rerender('6a30e7a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/MyCoverSummary.vue"
export default component.exports